<template>
  <MultiSelect
    v-if="multiple"
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :options="metodosDisponibles"
    optionLabel="nombre"
    optionValue="id"
    dataKey="id"
    :filter="filter"
    :placeholder="placeholder"
    :disabled="disabled || cargando"
    :loading="cargando"
    display="chip"
  />
  <Dropdown
    v-else
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)"
    :options="metodosDisponibles"
    optionLabel="nombre"
    optionValue="id"
    :filter="filter"
    :placeholder="placeholder"
    :disabled="disabled || cargando"
    :loading="cargando"
  />
</template>

<script>
import MetodoPagoService from '@/service/MetodoPagoService';

export default {
  name: 'SelectMetodoPago',
  props: {
    modelValue: {
      type: [String, Number, Object, Array],
      required: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Seleccione un método de pago'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Boolean,
      default: false
    },
    mostrarTodos: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      metodosDisponibles: [],
      cargando: false,
      metodoPagoService: new MetodoPagoService()
    }
  },
  mounted() {
    this.cargarMetodos();
  },
  methods: {
    async cargarMetodos() {
      this.cargando = true;
      try {
        const response = await this.metodoPagoService.getAllMetodoPagos();
        
        let data = Array.isArray(response) 
          ? response 
          : (response.data || response.metodo_pagos || Object.values(response).find(Array.isArray) || []);
        
        if (data && data.length >= 0) {
          this.metodosDisponibles = data.map(item => {
            return {
              id: item.id,
              nombre: item.nombre || item.descripcion
            };
          });
          
          if (this.mostrarTodos) {
            this.metodosDisponibles.unshift({ id: null, nombre: "TODOS" });
          }
        }
      } catch (error) {
        console.error("Error cargando métodos de pago para el Dropdown:", error);
      } finally {
        this.cargando = false;
      }
    }
  }
}
</script>

<style scoped>
</style>
